import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {NgRedux, select} from "@angular-redux/store";
import {Message, MessageType} from "../../../../shared/redux-store/session/session.types";
import {List} from "immutable";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {IAppState} from "../../../../shared/redux-store/store";
import {OverlayPanel} from "primeng/components/overlaypanel/overlaypanel";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {VisBOSMessage} from "./VisBOSMessage.interface";

@Component({
  selector: 'vb-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit, OnDestroy {

  @select(['session', 'messages'])
  messages$: Observable<List<Message>>;

  lastMessages: Message[] = [];
  allMessages: List<Message>;
  messagesSub: Subscription;

  @ViewChild('msgPanel')
  msgPanel: OverlayPanel;

  growlMessages$: Observable<VisBOSMessage[]>;
  growlMessages: VisBOSMessage[] = [];


  constructor(private sessionActions: SessionActions, private ngRx: NgRedux<IAppState>) {
  }

  ngOnInit() {
    this.growlMessages$ = this.sessionActions.growlMsgs;
    this.growlMessages$.subscribe(msgs => {
      this.growlMessages = msgs;
    });

    this.messagesSub = this.messages$.subscribe(msgs => {
      this.allMessages = msgs;
      this.lastMessages = JSON.parse(JSON.stringify(this.allMessages));
      this.lastMessages = this.lastMessages.reverse().slice(0, 10);
    });

  }

  togglePanel(e: Event) {
    this.msgPanel.toggle(e);
  }

  removeMessage(index) {
    let realIndex: number = this.allMessages.size - 1 - index;
    this.sessionActions.removeMessage(realIndex);
  }

  clearMessages() {
    this.sessionActions.clearAllMessages();
  }

  ngOnDestroy(): void {
    this.clearMessages();

    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }
  }

  setMessageClass(msg: Message) {
    return {
      'list-group-item-success': msg.type == MessageType.SUCCESS,
      'list-group-item-info': msg.type == MessageType.INFO,
      'list-group-item-warning': msg.type == MessageType.WARNING,
      'list-group-item-danger': msg.type == MessageType.ERROR
    }
  }

  setIconClass() {
    return {
      'text-danger': this.ngRx.getState().session.hasError,
      'text-success': !this.ngRx.getState().session.hasError
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/messages/messages.component.ts